import {
    DIC
} from '@/const/dic'
// import {
//     validateChinese
// } from '@/util/validate'
import {
    formatterDateToUTC
} from '@/util/util'
import {
    baseUrl
} from '@/config/env';


export const mobileRedPacketOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    columnBtn: false,
    //viewBtn: true,
    menuWidth: '200',
    labelWidth: '150',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [
        {
            label: "红包名称",
            prop: "redPacketName",
            span:13,
            type: 'input',
        },
        {
            label: "红包类型",
            prop: "payment",
            type: 'select',
            span:13,
            search:true,
            placeholder:'请选择红包类型',
            // valueDefault:"JOINS_ENGINEER",
            dicData:DIC.PAYMENT,
            addVisdiplay: false,
            editVisdiplay: false,
        }, 
      
        {
            label: "红包总额",
            prop: "redPacketTotal",
            span:13,
            type: 'input',
        },
        {
            label: "红包个数",
            prop: "redPacketNumber",
            span:13,
            type: 'input',
        },
        {
            label: "状态",
            prop: "status",
            type: 'select',
            span:13,
            search:true,
            placeholder:'请选择红包类型',
            // valueDefault:"JOINS_ENGINEER",
            dicData:DIC.SALES_RED_PACKED_STATUS,
            addVisdiplay: false,
            editVisdiplay: false,
        }, 
        {
            label: "红包有效期",
            prop: "startDate_endDate",
            type: "datetimerange",
            valueFormat: "timestamp",
            span: 24,
            clearable: true,
            width:"160",
            search: true,
            addVisdiplay: false,
            editVisdiplay: false,
            formatter: function (row, value, label, column) {
                return formatterDateToUTC(row.startDate) + '至' + formatterDateToUTC(row.endDate)
            }
        },
        {
            label: "创建时间",
            prop: "createTimeStart_createTimeEnd",
            type: "datetimerange",
            valueFormat: "timestamp",
            span: 24,
            clearable: true,
            width:"160",
            hide:true,
            search: true,
            addVisdiplay: false,
            editVisdiplay: false,
            formatter: function (row, value, label, column) {
                return formatterDateToUTC(row.createTimeStart) + '至' + formatterDateToUTC(row.createTimeEnd)
            }
        },
        {
            label: "创建时间",
            prop: "createTime",
            type: "datetime",
            // sortable: true,
            // search:true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        // {
        //     label: "更新人",
        //     prop: "createBy",
        //     type: "input",
        //     hide:true,
        //     addVisdiplay: false,
        //     editVisdiplay: false,
        //     width: "110"
        // },
    ]
};